"use strict";

document.addEventListener("DOMContentLoaded", () => {
    const sections = document.querySelectorAll('.gallery__content .one');
    const navLinks = document.querySelectorAll('.gallery__nav .nav ul li a');

    if (sections.length === 0 || navLinks.length === 0) return;

    const updateNav = () => {
        let currentId = "";

        sections.forEach(section => {
            const rect = section.getBoundingClientRect();
            if (rect.top <= 150) {
                currentId = section.getAttribute('id');
            }
        });

        navLinks.forEach(link => {
            link.parentElement.classList.remove('active');
        });

        if (currentId) {
            const activeLink = document.querySelector(`.gallery__nav .nav ul li a[href="#${currentId}"]`);
            if (activeLink) {
                activeLink.parentElement.classList.add('active');
            }
        }
    };

    window.addEventListener('scroll', updateNav);

    updateNav();
});